module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/funabashi_ekimae_point2-c183eb7818406b5934fbbdddfd4d763d.jpg";